import React, {useState} from "react";
import {Link, useLocation} from "react-router-dom";
import {FaCopy, FaLink} from "react-icons/fa";
import GaugeChartPreview from "./render";
import KpiChartPreview from "./render";

export const KpiChart = () => {
    const [copied, setCopied] = useState(false);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const [environment, setEnvironment] = useState(queryParams.get("environment") || "DEV");

    const [minValue, setMinValue] = useState(queryParams.get("minValue") || 0);
    const [maxValue, setMaxValue] = useState(queryParams.get("maxValue") || 200);
    const [height, setHeight] = useState(queryParams.get("height") || 350);
    const [currentValue, setCurrentValue] = useState(queryParams.get("currentValue") || 150);
    const [showValue, setShowValue] = useState(queryParams.get("showValue") || "Y");
    const [valuePosition, setValuePosition] = useState(queryParams.get("valuePosition") || "center");
    const [primaryColor, setPrimaryColor] = useState(queryParams.get("primaryColor") || "0066FF");
    const [secondaryColor, setSecondaryColor] = useState(queryParams.get("secondaryColor") || "012259");
    const [remainingColor, setRemainingColor] = useState(queryParams.get("remainingColor") || "ECECEC");
    const [fontFamily, setFontFamily] = useState(queryParams.get("fontFamily") || "Arial, sans-serif");
    const [colorBackground, setColorBackground] = useState(queryParams.get("colorBackground") || "FFFFFF");
    const [fontSize, setFontSize] = useState(queryParams.get("fontSize") || 22);



    const handleCopy = () => {
        navigator.clipboard.writeText(linkToCopy);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const linkToCopy =
        process.env.REACT_APP_FRONT_URL + "/veloster?na=1"
        + "&environment=PROD"
        + "&minValue=" + minValue
        + "&maxValue=" + maxValue
        + "&currentValue=" + currentValue
        + "&showValue=" + showValue
        + "&valuePosition=" + valuePosition
        + "&primaryColor=" + primaryColor
        + "&remainingColor=" + remainingColor
        + "&fontFamily=" + fontFamily
        + "&colorBackground=" + colorBackground
        + "&fontSize=" + fontSize;


    return (
        <div className="flex flex-col items-center justify-center" style={{width:'100%',backgroundColor:colorBackground}}>
            {environment=== "DEV" && (
                <>
                    <h1 style={{fontSize: 40, fontWeight: 'bold'}}>
                        Veloster Chart Component
                    </h1>
                    <br/><br/>
                    <h3 className="text-lg font-semibold mb-3">QUERY PARAMETERS</h3>
                    <br/>

                    <h3 className="text-md font-semibold mb-3 mt-10">Chart configuration</h3>
                    <div className="flex flex-wrap items-start justify-start gap-4 w-full">

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">colorPrimary</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Color del grafico
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setPrimaryColor(e.target.value)}
                                        value={primaryColor}
                                    />
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">colorSecondary</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Color secundario del grafico
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setSecondaryColor(e.target.value)}
                                        value={secondaryColor}
                                    />
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">remainingColor</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Color gris de fondo
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setRemainingColor(e.target.value)}
                                        value={remainingColor}
                                    />
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">height</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Ancho del Componente
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setHeight(e.target.value)}
                                        value={height}
                                    />
                                </p>
                            </div>
                        </div>


                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">minValue</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Valor Inicial
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setMinValue(e.target.value)}
                                        value={minValue}
                                    />
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">maxValue</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Valor Maximo
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setMaxValue(e.target.value)}
                                        value={maxValue}
                                    />
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">currentValue</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Valor Actual
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setCurrentValue(e.target.value)}
                                        value={currentValue}
                                    />
                                </p>
                            </div>
                        </div>


                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">showLegend</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Muestra el valor del grafico?
                                    <br/>
                                    <select
                                        className="block w-full mt-1 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                        onChange={(e) => setShowValue(e.target.value)}
                                        value={showValue}>
                                        <option value="Y">Y</option>
                                        <option value="N">N</option>
                                    </select>
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">valuePosition</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Posicion del valor del grafico
                                    <br/>
                                    <select
                                        className="block w-full mt-1 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                        onChange={(e) => setValuePosition(e.target.value)}
                                        value={valuePosition}>
                                        <option value="center">center</option>
                                        <option value="outside">outside</option>
                                    </select>
                                </p>
                            </div>
                        </div>


                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">fontFamily</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Tipografia
                                    <br/>
                                    <select
                                        className="block w-full mt-1 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                        onChange={(e) => setFontFamily(e.target.value)}
                                        value={fontFamily}>
                                        <option value="Arial, sans-serif">Arial, sans-serif</option>
                                        <option value="Courier New, monospace">Courier New, monospace</option>
                                        <option value="Helvetica, sans-serif">Helvetica, sans-serif</option>
                                        <option value="Verdana, sans-serif">Verdana, sans-serif</option>
                                        <option value="Tahoma, sans-serif">Tahoma, sans-serif</option>
                                        <option value="Trebuchet MS, sans-serif">Trebuchet MS, sans-serif</option>
                                        <option value="Open Sans, sans-serif">Open Sans, sans-serif</option>
                                        <option value="Roboto, sans-serif">Roboto, sans-serif</option>
                                    </select>
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">fontSize</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Tamaño de fuente
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setFontSize(e.target.value)}
                                        value={fontSize}
                                    />
                                </p>
                            </div>
                        </div>

                    </div>
                    <h3 className="text-lg font-semibold mb-3">PREVIEW</h3>

                    <br/><br/>
                </>)}

            <KpiChartPreview
                minValue={minValue}
                maxValue={maxValue}
                currentValue={currentValue}
                showValue={showValue === "Y"}
                valuePosition={valuePosition}
                gaugeColor={primaryColor}
                gaugeColorSecondary={secondaryColor}
                remainingColor={remainingColor}
                height={height}
                fontSize={fontSize}
                fontFamily={fontFamily}
            />


            {environment === "DEV" && (
                <div>
                    <br/><br/>
                    <div className="flex items-center mb-5">
                        <button
                            onClick={handleCopy}
                            className="mr-4 bg-blue-500 text-white p-2 rounded-lg flex items-center hover:bg-blue-600"
                        >
                            <FaCopy className="mr-2"/>
                            {copied ? "Copied!" : "Copy Link"}
                        </button>

                        <Link to={"/"}>
                            <button className="mr-4 bg-blue-500 text-white p-2 rounded-lg flex items-center hover:bg-blue-600" >
                                <FaLink className="mr-2"/>
                                Go to Home
                            </button>
                        </Link>
                    </div>

                </div>
            )}
        </div>

    );
};
